<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view>
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-map />
      <o-section-header title="Tankstations" />
      <o-empty-state
        icon="sad"
        icon-style="light"
        label="We hebben geen tankstations kunnen vinden in jouw buurt."
      />
    </o-view>
    <o-pay-button
      label="Probeer opnieuw"
      to="/sales/fuel/q8/stations/results"
    />
  </o-view>
</template>

<script>
import OEmptyState from '@/components/OEmptyState.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OEmptyState,
    OMap,
    OPayButton
  }
}
</script>

<style lang="scss"></style>
